import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { filter, take, takeUntil } from 'rxjs/operators';
import { AuthService } from '../services/auth.service';

const AUTO_LOGIN_SKIP = ['/callback', '/logout'];

function skipsAutoLogin(url: string): boolean {
  const path = url.split('?')[0].split('#')[0];
  return AUTO_LOGIN_SKIP.some(route => path === route || path.startsWith(route + '/'));
}

/** Starts the Auth0 login redirect once loading finishes. Callback and logout own that flow. */
export function redirectToLoginWhenSignedOut(
  authService: AuthService,
  router: Router,
  destroy$: Observable<unknown>
): void {
  if (skipsAutoLogin(router.url)) {
    return;
  }

  authService.isLoading$.pipe(
    filter(isLoading => !isLoading),
    takeUntil(destroy$)
  ).subscribe(() => {
    authService.isAuthenticated$.pipe(
      take(1),
      takeUntil(destroy$)
    ).subscribe(isAuthenticated => {
      if (!isAuthenticated && !skipsAutoLogin(router.url)) {
        authService.login();
      }
    });
  });
}
